import { PARTICIPANT_PROFILE_ERROR, PARTICIPANT_PROFILE_SUCCESS, PARTICIPANT_EDIT_PROFILE, PARTICIPANT_VIEW_PROFILE, PARTICIPANT_RESET_PROFILE_FLAG, PARTICIPANT_PASSWORD_CHANGE } from "./actionTypes"

export const viewParticipantProfile = (callback) => {
  return {
    type: PARTICIPANT_VIEW_PROFILE,
    payload: { callback },
  }
}

export const editParticipantProfile = (user, callback) => {
  return {
    type: PARTICIPANT_EDIT_PROFILE,
    payload: { user, callback },
  }
}

export const passwordParticipantChange = (data, callback) => {
  return {
    type: PARTICIPANT_PASSWORD_CHANGE,
    payload: { data, callback },
  }
}

export const profileParticipantSuccess = msg => {
  return {
    type: PARTICIPANT_PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileParticipantError = error => {
  return {
    type: PARTICIPANT_PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileParticipantFlag = error => {
  return {
    type: PARTICIPANT_RESET_PROFILE_FLAG,
  }
}
